import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';

import { catalogBibShape, recommendationShape } from '@bibliocommons/bc-prop-types';

import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectRecommendationsForCurrentBib } from 'app/selectors/bibs/DiscoverySelector';

import Recommendations from './Recommendations';

export class RecommendationsContainer extends React.PureComponent {
  render() {
    return <Recommendations {...this.props} />;
  }
}

RecommendationsContainer.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  recommendations: ImmutablePropTypes.listOf(recommendationShape).isRequired
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  recommendations: selectRecommendationsForCurrentBib(state)
});

export default connect(mapStateToProps)(RecommendationsContainer);
